export default __webpack_public_path__ + "static/media/sort-down.f81baac1.svg";